import CountUp from "react-countup";

export default function HomeCounter() {
  return (
    <section className="home-counter">
      <div className="container">
        <div className="row">

          <div className="col-6 col-lg-3 col-md-3" >
            <div className="homecount-box">
              <h3>
                <CountUp end={550} enableScrollSpy />
                <label>+</label>
              </h3>
              <p>Successful Projects</p>
            </div>
          </div>

          <div className="col-6 col-lg-3 col-md-3">
            <div className="homecount-box">
              <h3>
                <CountUp end={15} enableScrollSpy />
                <label>+</label>
              </h3>
              <p>Years</p>
            </div>
          </div>

          <div className="col-6 col-lg-3 col-md-3" >
            <div className="homecount-box">
              <h3>
                <CountUp end={450} enableScrollSpy />
                <label>+</label>
              </h3>
              <p>Clients</p>
            </div>
          </div>

          <div className="col-6 col-lg-3 col-md-3">
            <div className="homecount-box">
              <h3>
                <CountUp end={100} enableScrollSpy />
                <label>%</label>
              </h3>
              <p>Happiness</p>
            </div>
          </div>
        </div>
      </div>

      {/* Optimized Image Loading */}
      <span className="counter-vector-1">
        <img src="/assets/home/element.png" alt="vector" loading="lazy" />
      </span>
      <span className="counter-vector-2">
        <img src="/assets/home/element.png" alt="vector" loading="lazy" />
      </span>
    </section>
  );
}
